import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { find, cloneDeep, get, capitalize, map, sortBy, uniqBy } from 'lodash';
import store from '../../helpers/store'
import ReactSelect from '../../components/common/ReactSelect';
import SearchWidget from '../../components/pages/home/SearchWidget';
import FilterList from '../../components/widgets/entityFilter/FilterList';
import EntitiesList from '../../components/widgets/entityFilter/EntitiesList';
import CSVImportModal from '../../components/common/CSVImportModal';
import CSVSampleDownload from '../../components/common/CSVSampleDownload';
import FieldMapper from '../../components/widgets/entityFilter/FieldMapper';
import Spinner from '../../components/common/Spinner';
import CountryFlag from '../../components/common/CountryFlag';
import ConfirmClick from '../../components/common/ConfirmClick';
import MatchMediaWrapper from '../../helpers/MatchMediaWrapper';
import MailingList from '../../components/pages/mailingLists/MailingList';
import countriesByAbbreviation from '../../components/common/CountriesByAbbreviation';

import { entityFiltersActions } from '../../data/actions/entity_filters';
import { searchActions } from '../../data/actions/search';
const allEntityTypes = ['imprints', 'artists', 'products', 'projects', 'tracks'];
const deleteSvg = require('!svg-inline-loader!../../../public/img/icons/delete.svg');
const editSvg = require('!svg-inline-loader!../../../public/img/icons/edit.svg');

class TerritoryFilterDetails extends React.Component {

	constructor(props){
		super(props);
		// const currentFilter = store.get('userEntityFilter') || null;
		this.state = {
			currentFilter: null,
			existingFilter: null,
			searchActive: false,
			entityType: null,
			entitySearchResults: null,
			showFieldMapper: false,
			importTarget: null,
			mailingListExpanded: true
		}
		this.setFilterState = this.setFilterState.bind(this);
		this.addNewFilter = this.addNewFilter.bind(this);
		this.addToFilter = this.addToFilter.bind(this);
		this.addAllToFilter = this.addAllToFilter.bind(this);
		this.bulkAddToFilter = this.bulkAddToFilter.bind(this);
		this.dummyBulkAddToFilter = this.dummyBulkAddToFilter.bind(this);
		this.addMappedResultsToFilter = this.addMappedResultsToFilter.bind(this);
		this.selectFilter = this.selectFilter.bind(this);
		this.selectFilterByID = this.selectFilterByID.bind(this);
		this.updateFilterField = this.updateFilterField.bind(this);
		this.removeFromFilter = this.removeFromFilter.bind(this);
		this.saveFilter = this.saveFilter.bind(this);
		this.deleteFilter = this.deleteFilter.bind(this);
		this.resetFilter = this.resetFilter.bind(this);
		this.addRecentFilter = this.addRecentFilter.bind(this);
		this.setSearchActive = this.setSearchActive.bind(this);
		this.goToDetails = this.goToDetails.bind(this);
		this.updateTitle = this.updateTitle.bind(this);
		this.setMailingListExpanded = this.setMailingListExpanded.bind(this);
	}
	
	componentDidMount(){
		
		const { match, dispatch, user } = this.props; 
		const { id } = match.params;
		let getFilterData, mode;
		if(id == 'new') {
			getFilterData = Promise.resolve(this.getNewFilter());
			mode = 'new';
		}
		else {
			getFilterData = dispatch(entityFiltersActions.getEntityFilter(id))
			mode = 'edit';
		}
		
		getFilterData.then(currentFilter=>{
			if(!currentFilter || !(currentFilter.user_id == user.user.id)) {
				this.props.history.push('/territories/filters');
				return false;
			}
				
			
			this.setState({currentFilter, mode, existingFilter: cloneDeep(currentFilter)});
		})
	
	}
	
	getNewFilter() {
		const { user } = this.props; 
		return {
			name: 'New Filter', 
			user_id: user.user.id,
			body: [],
			is_shared: false,
			is_system: false
		};
	}
	
	addNewFilter() {
		const name = prompt('New Filter Name')
		if(!name)
			return;
		
		this.props.dispatch(entityFiltersActions.createFilter({
			...this.state.currentFilter,
			name
		})).then(()=>this.props.history.push('/territories/filters'));
	}
	
	renderRecentFilters() {
		const { currentFilter, recentFilters } = this.state;
		return <FilterList currentFilter={currentFilter} filters={recentFilters} onSelect={this.selectFilterByID} />
	}
	
	renderPinnedFilters() {
		const { currentFilter } = this.state,
			{ filters = [] } = this.props.userEntityFilters;
		const pinnedFilters = filters.filter(filter=>filter.is_pinned);
		return <FilterList currentFilter={currentFilter} filters={pinnedFilters} onSelect={this.selectFilterByID} />        
	}
	
	addRecentFilter(filter) {
		let recentFilters = store.get('recentEntityFilters') || [];
		const newFilter = {id: filter.id, caption: filter.caption};
		if(!find(recentFilters, filter=>filter.id == newFilter.id)) {
			recentFilters.unshift(newFilter);
			store.set('recentEntityFilters', recentFilters);
			return new Promise((resolve) => this.setState({recentFilters}, resolve));
		}
		else 
			return Promise.resolve();
	}
	
	renderCountries(){
		const countries = countriesByAbbreviation.map(c=>({
			label: c.country,
			value: c.abbreviation
		}));
		return <ReactSelect
			options={countries}
			placeholder="Search..."
			onChange={this.addToFilter}
			closeMenuOnSelect={false}
		/>
	}
	
	setFilterState(currentFilter, callback) {
		//store.set('userEntityFilter', currentFilter);
		this.setState({
			...this.state,
			currentFilter,
			searchActive: false
		}, callback);
	}
	
	selectFilter(currentFilter) {
		this.addRecentFilter(currentFilter)
		.then(()=>{
			this.setFilterState(currentFilter);
		});
	}
	
	selectFilterByID(id) {
		const { filters = [] } = this.props.userEntityFilters;
		const currentFilter = find(filters, filter=>filter.id == id);
		if(currentFilter)
			this.selectFilter(currentFilter);
	}
	
	addToFilter(item) {
		const { id: filterID, body } = this.state.currentFilter;
		const newItem = {
			code: item.value,
			name: item.label
		}
		let newEntities = cloneDeep(body);
		
		if(!find(newEntities, e=>e.code == newItem.code)) {
			newEntities.push(newItem);
			newEntities = sortBy(newEntities, 'name');
		}
			
		this.setFilterState({
			...this.state.currentFilter,
			body: newEntities 
		});
	}
	
	addAllToFilter(items, include) {
		let newItems = [];
		for(let key of Object.keys(items)) {
			if(Array.isArray(items[key])) {
				newItems = newItems.concat(items[key])
			}
		}
		this.addToFilter(newItems, include);
	}
	
	bulkAddToFilter(fields) {
		if(!fields.length)
			return;
		let countries = [];	
		for(let field of fields) {
			const { country } = field;
			const comparisonField = country.length == 2 ? 'abbreviation' : 'country';
			const countryData = find(countriesByAbbreviation, c=>c[comparisonField]==country);
			if(countryData) {
				countries.push({
					code: countryData.abbreviation,
					name: countryData.country
				})
			}
		}	
		if(countries.length) {
			const body = uniqBy([...countries, ...this.state.currentFilter.body], 'code');
			this.setState({
				...this.state,
				currentFilter: {
					...this.state.currentFilter, 
					body
				}
			})
		}
		return Promise.resolve(true);
	}
	
	dummyBulkAddToFilter() {
		const fields = [{
			'target': 'include',
			'source': 'artists',
			'field': 'Mitski'
		}, {
			'target': 'include',
			'source': 'artists',
			'field': 'Marco'            
		}];
		let { target, source } = fields[0];
		const searchString = map(fields, 'field').join('\n');
		this.props.dispatch(searchActions.getSearchImport(searchString, [source]))
		.then(results=>{
			this.setState({
				entitySearchResults: results,
				showFieldMapper: true,
				importTarget: target
			})
		});
	}
	
	addMappedResultsToFilter(results) {
		const { importTarget } = this.state;
		const filteredResults = results.filter(result=>(result.id !== null));
		this.addToFilter(filteredResults, (importTarget == 'include'));
		this.setState({
			entitySearchResults: null,
			showFieldMapper: false,
			importTarget: null
		});
		console.log('addMappedResultsToFilter')
		
		return Promise.resolve();
	}
	
	removeFromFilter(code) {
		const { body } = this.state.currentFilter;
		let newEntities = body.filter(c=>!(c.code==code));
		this.setFilterState({
			...this.state.currentFilter,
			body: newEntities 
		});
	}
	
	updateFilterField(field, value) {
		const { id } = this.state.currentFilter;
		this.setFilterState({
			...this.state.currentFilter,
			[field]:value 
		}, ()=>{
			this.props.dispatch(entityFiltersActions.updateEntityFilter(id,this.state.currentFilter ))    
		})
		
	}
	
	updateTitle() {
		const name = prompt('Change Filter Name')
		if (!name)
			return;

		this.updateFilterField('name', name)
	}
	
	saveFilter() {
		const { currentFilter } = this.state;
		this.props.dispatch(entityFiltersActions.updateEntityFilter(currentFilter.id, currentFilter))
		.then(()=>this.props.history.push('/territories/filters'));
	}
	
	deleteFilter() {
		const { id } = this.state.currentFilter;
		this.props.dispatch(entityFiltersActions.destroyFilter(id))
		.then(()=>this.props.history.push('/territories/filters'));
	}
	
	setSearchActive(searchActive) {
		this.setState({searchActive});
	}
	
	goToDetails() {
		const { entities } = this.state.currentFilter;
		let filter = {};
		for(let entity of entities){
			const { fav_hide, entity_type, entity_id } = entity;
			if(fav_hide == 'favorite') {
				if(!filter.hasOwnProperty(entity_type))
					filter[entity_type] = [];
				filter[entity_type].push(entity_id);
			}
		}
		this.props.history.push(`/filter/${JSON.stringify(filter)}`);
	}
	
	resetFilter(){
		this.setFilterState(null, ()=>{
			this.props.applyFilter();
		})
	}
	
	renderFilterSelect() {
		const { currentFilter } = this.state,
			{ loading, filters = [] } = this.props.userEntityFilters,
			filterOptions = filters.map(filter=>({label: filter.caption, value: filter})),
			selectedFilter = currentFilter ? find(filterOptions, option=>option.value.id == currentFilter.id) : null;
			
		return <ReactSelect
			loading
			value={selectedFilter}
			options={filterOptions}
			onChange={({value})=>this.selectFilter(value)}
			isLoading={loading}
			isSearchable={true}
			onFocus={()=>this.setSearchActive(true)}
		/>
	}
	
	renderFilterEntities(entities) {
		if(!entities)
			return null;
		
		const entitiesInFilter = entities.length;
		return <div className="pinned-filters-holder filter-page">
			{entitiesInFilter == 0 && <p className="select-entity-text">Select country from the search bar to to include it.</p>}
			{entitiesInFilter > 0 && <div className="tag-list">
							<div className="page-filter-item">
								<div className="page-filter-list">
									{entities.map(entity=><div key={entity.code} className="tag">
										<div className="tag-name-holder">
											<div className="tag-name">
												<CountryFlag country={entity.code} />
												<span>{entity.name}</span>
											</div>
											<a
												className="close-link"
												onClick={()=>this.removeFromFilter(entity.code)}
											>
												&times;
											</a>
										</div>
									</div>)}
								</div>
							</div>
						</div>}
		</div>
	}

	renderMailingList(filter) {
		const {mailingListExpanded} = this.state;
		return <div className="mailing-list-holder filter-notification-settings">
			{/*<p className={`mailing-list-toggle ${mailingListExpanded?'mailing-list-toggle-expanded':''}`} onClick={this.setMailingListExpanded}>Manage Notification Settings</p> */}
			{mailingListExpanded && <MailingList entityFilterId={filter.id} />}
		</div>
	}
			
	setEntityType(entityType) {
		this.setState({entityType});
	}
	
	setMailingListExpanded(mailingListExpanded) {
		this.setState({mailingListExpanded: !this.state.mailingListExpanded});
	}
	
	render() {
		const { currentFilter: filter , searchActive, mode, entityType, showFieldMapper, entitySearchResults }  = this.state;
		const { applyFilter, search: { importLoading } } = this.props;
		const onClickAction = (mode == 'new') ? this.addNewFilter : this.saveFilter;
		const filterCSVFields = [ 
			 {key: 'country', required: false, label: '2 letter ISO country code or country name', placeholder: 'US or United States'}
		 ];
		
		return (
			 <div className="user-entity-filter-holder create-filter">
				<div className="container">
					<div className="import-menu import-menu-main import-menu-no-padding">
						<ul>
							<li><Link to={`/territories`}>Territory Dashboard</Link></li>
							<li><Link to={`/territories/filters`}>Saved Filters</Link></li>
							<li>{capitalize(mode)} Filter</li>
						</ul>
					</div>

				
					{mode == 'edit' ? <h3 className="user-filter-title">Edit Saved Filter</h3> : <h3 className="user-filter-title">Add Saved Filter</h3>}
					{filter && <div className="user-entity-filter">
						<div className="user-filter-search-container">
							<p className="text">Search countries to include to filter</p>
							<div className="add-filter-search-holder">
								{this.renderCountries()}
								<Spinner enabled={importLoading} className="spinner spinner-inline"  />
								<MatchMediaWrapper isMobile={false} breakpoint={639}>
									<div className="search-holder-btns">
										<CSVImportModal fields={filterCSVFields} buttonClass="default-btn default-btn--small milestone-import-btn default-btn--light" modalTitle="Import To Filter" buttonTitle="Choose File" onSubmit={this.bulkAddToFilter} />                         
										<CSVSampleDownload fields={filterCSVFields} linkClass="button-no-style download-scv" linkTitle="Download Sample" />
										{/* <button onClick={this.dummyBulkAddToFilter}>Demo Search</button> */}
									</div>
								</MatchMediaWrapper>
							</div>
						</div>
						<div className="current-filter-holder"> 
							<div className="current-filter-title-holder">
							<h3 className="current-filter-title">{filter.name}</h3>
							{mode == 'edit' && <button className="update-filter-title" onClick={()=>{this.updateTitle()}}>
								<span dangerouslySetInnerHTML={{__html: editSvg}}/>
							</button>}
							</div>
							<div className="results-holder">
							{this.renderFilterEntities(filter.body)}
							<div className="entity-filter-dropdown-list">
								{mode == 'edit' && <button onClick={this.saveFilter} className="default-btn default-btn--small update-filter">Update Filter</button>}
								<button onClick={this.addNewFilter} className="default-btn default-btn--small default-btn--light">Save As New Filter</button>
								{mode == 'edit' && <div className="entity-filter-action"> 
									<div className="checkbox-holder checkbox-holder--block checkbox-switcher-holder">
										<input type="checkbox" id="filter_is_shared" checked={filter.is_shared} onChange={()=>this.updateFilterField('is_shared', !filter.is_shared)} className="input" />
										<label htmlFor="filter_is_shared" className="checkbox-label checkbox-switcher">Share</label>
									</div>
									{/*
									<div className="checkbox-holder checkbox-holder--block checkbox-switcher-holder">
										<input type="checkbox" id="filter_is_pinned" checked={filter.is_pinned} onChange={()=>this.updateFilterField('is_pinned', !filter.is_pinned)} className="input" />
										<label htmlFor="filter_is_pinned" className="checkbox-label checkbox-switcher">Pin</label>
									</div>
									<div className="checkbox-holder checkbox-holder--block checkbox-switcher-holder">
										<input type="checkbox" id="filter_is_hidden" checked={filter.is_hidden} onChange={()=>this.updateFilterField('is_hidden', !filter.is_hidden)} className="input" />
										<label htmlFor="filter_is_hidden" className="checkbox-label checkbox-switcher">Hide</label>
									</div> 
									*/}
								</div>}
							</div>
							{mode == 'edit' && <div>
								<ConfirmClick confirmAction={()=>this.deleteFilter()} confirmClass="remove-filter-link filter-reset-btn button-no-style" confirmLabel={<span><span className="tiny-icon" dangerouslySetInnerHTML={{__html: deleteSvg}}></span>Delete Filter</span>} confirmPrompt="Delete Filter?" title="Delete"></ConfirmClick>
							</div>}
						</div>                    
					</div>
					</div>}          
				</div>
			</div>   
		)
	}
}

function mapStateToProps(state) {
	return {
		ntityFilters: state.entity_filters,
		search: state.search,
		user: state.user
	} 
}
export default connect(mapStateToProps)(withRouter(TerritoryFilterDetails));